import { operationsNewTotals } from "@redotech/redo-model/analytics/returns-claims/return-analytics-statistics";
import * as z from "zod";

export const getOperationsNewTotals = operationsNewTotals;

export type OperationsNewTotals = z.infer<typeof getOperationsNewTotals.output>;
